// extracted by mini-css-extract-plugin
export default {"flexDiv":"ProductList_flexDiv__Cpfkk","sidePanel":"ProductList_sidePanel__YD9QU"};